import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as currentUserActions from 'actions/currentUserActions';
import classnames from 'classnames';
import * as eventbriteActions from 'actions/eventbriteActions';
import * as appActions from 'actions/appActions';
import * as googlePlaceActions from 'actions/googlePlaceActions';
import * as countriesActions from 'actions/countriesActions';
import { Alert } from 'reactstrap';

class AppContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    userLoggedIn: PropTypes.bool.isRequired,
    userDataLoading: PropTypes.bool.isRequired,
    checkUserData: PropTypes.func.isRequired,
    loginRequired: PropTypes.bool,
    initializeEventbrite: PropTypes.func.isRequired,
    eventbrite: PropTypes.object.isRequired,
    hideAppFatalError: PropTypes.func.isRequired,
    appGlobalError: PropTypes.string,
    appGlobalInfo: PropTypes.string,
    venue: PropTypes.object,

    loadPlaceDataFromPlaceId: PropTypes.func.isRequired,
    loadPlaceDataFromVenue: PropTypes.func.isRequired,
    fetchCountries: PropTypes.func.isRequired,
  };

  static defaultProps = {
    loginRequired: true,
  }

  canBeGeocoded() {
    const { venue } = this.props;

    return !!(venue.address_1 && venue.town && venue.country);
  }

  componentWillMount() {
    const { venue } = this.props;

    this.props.checkUserData();
    if (!this.props.eventbrite.get('initialized', false)) {
      this.props.initializeEventbrite();
    }

    this.props.fetchCountries(() => {
      if (venue) {
        if (!venue.name && venue.place_id) {
          this.props.loadPlaceDataFromPlaceId(venue.place_id);
        }

        if (!venue.lat && !venue.lng && this.canBeGeocoded()) {
          this.props.loadPlaceDataFromVenue(venue);
        }
      }
    });
  }

  render() {
    const {
      userLoggedIn, userDataLoading, children,
      loginRequired, appGlobalError, appGlobalInfo
    } = this.props;

    if (!userLoggedIn && loginRequired) { return (<span>Unauthorized</span>); }

    return (
      <div className={classnames('EvvntApp', { 'is-loading': userDataLoading })}>
        <Alert color="danger" isOpen={appGlobalError !== null} toggle={this.props.hideAppFatalError}>
          {appGlobalError}
          <hr />
          <p className="mb-0">
            We’ve been notified, but please raise a support ticket with us <a href="https://support.evvnt.com/hc/en-us/requests/new">here</a>.
          </p>
        </Alert>
        <Alert color="info" isOpen={appGlobalInfo !== null} toggle={this.props.hideAppGlobalInfo}>
          {appGlobalInfo}
        </Alert>
        {this.props.eventbrite.get('isRedirecting') ? 'Please wait...' : children}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userLoggedIn: state.currentUser.get('isLoggedIn'),
  userDataLoading: state.currentUser.get('isLoading'),
  eventbrite: state.eventbrite,
  appGlobalError: state.app.get('globalError'),
  appGlobalInfo: state.app.get('globalInfo'),
  prices: state.form.eventSubmission.values.prices,
  currencies: state.currencies,
  currency: state.form.eventSubmission.values.currency,
  venue: state.form.eventSubmission.values.venue,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(eventbriteActions, dispatch),
  ...bindActionCreators(appActions, dispatch),
  ...bindActionCreators(googlePlaceActions, dispatch),
  ...bindActionCreators(countriesActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/AppContainer.jsx